import React, { useState, useEffect } from 'react';
import './App.css';

const App = () => {
  const [name] = useState('Teste'); // Nome fixo para testes
  const [drawnNumber, setDrawnNumber] = useState<number | null>(null);
  const [chatMessage, setChatMessage] = useState('');
  const [winner, setWinner] = useState('');

  const handleDrawNumber = (number: number) => {
    setDrawnNumber(number);
  };

  const handleChatMessage = (message: string) => {
    setChatMessage(message);
  };

  const handleWinner = (winnerName: string) => {
    setWinner(winnerName);
  };

  const handleStartGame = () => {
    console.log("Jogo iniciado!");
  };

  // Simula eventos para testes (opcional, pode remover após testar)
  useEffect(() => {
    // Simula um número sorteado após 5 segundos
    setTimeout(() => handleDrawNumber(42), 5000);
    // Simula uma mensagem de chat após 10 segundos
    setTimeout(() => handleChatMessage("Bingo"), 10000);
    // Simula um vencedor após 15 segundos
    setTimeout(() => handleWinner("João"), 15000);
  }, []);

  return (
    <div className="App">
      <div className="game-overlay">
        <h1>Bem-vindo, {name}!</h1>
        <button onClick={handleStartGame}>Iniciar Jogo</button>
        {drawnNumber && (
          <div className="drawn-number">
            Número sorteado: <span className="number-circle">{drawnNumber}</span>
          </div>
        )}
        {chatMessage && (
          <div className="chat-message">
            Chat: {chatMessage} 🔥
          </div>
        )}
        {winner && (
          <div className="winner">
            Vencedor: {winner}! 🎉
          </div>
        )}
      </div>
    </div>
  );
};

export default App;